import { Card, CardContent } from '@/components/ui/card';
import { BacklogStats as BacklogStatsType } from '@/types/itBacklog';
import { ListTodo, AlertTriangle, Clock, CheckCircle } from 'lucide-react';

interface BacklogStatsProps {
  stats: BacklogStatsType | undefined;
  isLoading: boolean;
}

export function BacklogStats({ stats, isLoading }: BacklogStatsProps) {
  const statCards = [
    {
      label: 'Total Pendente',
      value: stats?.total ?? 0,
      icon: ListTodo,
      color: 'text-blue-600 bg-blue-100 dark:bg-blue-900/30 dark:text-blue-400',
    },
    {
      label: 'Esta Semana',
      value: stats?.thisWeek ?? 0,
      icon: Clock,
      color: 'text-indigo-600 bg-indigo-100 dark:bg-indigo-900/30 dark:text-indigo-400',
    },
    {
      label: 'Críticos/Urgentes',
      value: stats?.critical ?? 0,
      icon: AlertTriangle,
      color: 'text-red-600 bg-red-100 dark:bg-red-900/30 dark:text-red-400',
    },
    {
      label: 'Concluídos (Semana)',
      value: stats?.completedThisWeek ?? 0,
      icon: CheckCircle,
      color: 'text-green-600 bg-green-100 dark:bg-green-900/30 dark:text-green-400',
    },
  ];
  
  if (isLoading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {[...Array(4)].map((_, i) => (
          <Card key={i} className="animate-pulse">
            <CardContent className="p-4">
              <div className="h-16 bg-muted rounded" />
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {statCards.map((stat) => {
        const Icon = stat.icon;
        return (
          <Card key={stat.label} className="border-none shadow-sm">
            <CardContent className="p-4">
              <div className="flex items-center gap-3">
                <div className={`p-2 rounded-lg ${stat.color}`}>
                  <Icon className="h-5 w-5" />
                </div>
                <div>
                  <p className="text-2xl font-bold">{stat.value}</p>
                  <p className="text-xs text-muted-foreground">{stat.label}</p>
                </div>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
